class AppointmentModal {

    constructor(selector = '.appointment-modal') {

        this.$modal = $(selector);
        
        if (!this.$modal.length) {
            console.error('Appointment modal not found.');
            return;
        }
        
        this.state = {
            step: 0,
            submitting: false,
            store: {
                bookingSite: '',
                bookingUrl: '',
                name: '',
                address: '',
                phone: ''
            },
            appointment: {
                siteId: null,
                date: null,
                time: null,
                bookingToken: null
            },
            customer: {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                // carrier: ''
                // reason: ''
            },
            confirmation: null
        };

        this.cacheDom();
        this.bindEvents();
        // this.populateDropdowns();
    }

    cacheDom() {

        this.$dialog = this.$modal.find('.appointment-modal__dialog');
        
        this.$pages = this.$modal.find('.appointment-page');
        this.$pagesContainer = this.$modal.find('.appointment-pages');
        
        this.$stepHeader = this.$modal.find('[data-step-header]');
        this.$stepLabel = this.$modal.find('[data-step-label]');
        this.$stepTitle = this.$modal.find('[data-step-title]');

        this.$storeName = this.$modal.find('[data-store="name"]');
        this.$storeAddress = this.$modal.find('[data-store="address"]');
        this.$storePhone = this.$modal.find('[data-store="phone"]');

        this.$dates = this.$modal.find('[data-container="dates"]');
        this.$times = this.$modal.find('[data-container="times"]');
        this.$timeList = this.$modal.find('[data-time-list]');

        this.$loading = this.$modal.find('[data-loading]');

        this.$next = this.$modal.find('[data-action="next"]');
        this.$back = this.$modal.find('[data-action="back"]');

        this.$dateSection = this.$modal.find('[data-date-section]');
        this.$dateSummary = this.$modal.find('[data-date-summary]');
        this.$selectedDate = this.$modal.find('[data-selected-date]');
        this.$contactError = this.$modal.find('[data-contact-error]');
        this.$bookingMessage = this.$modal.find('[data-booking-error]');

        this.$bookingMessage.attr({
            role: 'status',
            'aria-live': 'polite'
        });

        // Cache all form fields
        this.fields = {
            firstName: this.$modal.find('[data-field="firstName"]'),
            lastName: this.$modal.find('[data-field="lastName"]'),
            email: this.$modal.find('[data-field="email"]'),
            phone: this.$modal.find('[data-field="phone"]'),
            // carrier: this.$modal.find('[data-field="carrier"]')
            // reason: this.$modal.find('[data-field="reason"]')
        };

        this.errors = {
            firstName: this.$modal.find('[data-error-for="firstName"]'),
            lastName: this.$modal.find('[data-error-for="lastName"]'),
            email: this.$modal.find('[data-error-for="email"]'),
            phone: this.$modal.find('[data-error-for="phone"]'),
            // carrier: this.$modal.find('[data-error-for="carrier"]')
            // reason: this.$modal.find('[data-error-for="reason"]')
        };

    }

    bindEvents() {

        const self = this;

        // Close button & overlay
        this.$modal.on('click', '[data-action="close"]', function () {
            if (self.state.submitting) {
                return;
            }

            self.close();
        });

        // ESC
        $(document).on('keydown', function (e) {
            if ( e.key === 'Escape' && self.isOpen() && !self.state.submitting ) {
                self.close();
            }
        });

        this.$modal.on('click', '[data-change-date]', () => {

            this.$dateSummary.slideUp(200, () => {
                this.$dateSummary.attr('hidden', true);

                this.$dateSection.removeClass('is-collapsed');
            });

            this.$stepTitle.text(
                window.appointmentTranslations.select_date
            );

            this.$times.empty();
            this.$next.prop('disabled', true);
            this.state.appointment.time = null;
        });

        // Footer buttons
        this.$next.on('click', function () {
            self.next();
        });

        this.$back.on('click', function () {
            self.back();
        });

        // Date selection
        this.$dates.on('click', '.appointment-date', (e) => {
            const $card = $(e.currentTarget);
            this.selectDate($card);
        });

        // Time selection
        this.$times.on('click', '.appointment-time', (e) => {
            const $card = $(e.currentTarget);
            this.selectTime($card);
        });

    }

    setSubmitting(submitting) {
        this.state.submitting = submitting;

        this.$next.prop('disabled', submitting);
        this.$back.prop('disabled', submitting);

        if (submitting) {
            this.$next.text(window.appointmentTranslations.booking);
        } else {
            if (this.state.step === 2) {
                this.$next.text(window.appointmentTranslations.book);
            } else if (this.state.step === 3) {
                this.$next.text(window.appointmentTranslations.done);
            } else {
                this.$next.text(window.appointmentTranslations.continue);
            }
        }

        this.$loading.prop('hidden', !submitting);
    }

    populateDropdowns() {

        // const carriers = [
        //     '',
        //     'Bell',
        //     'Rogers',
        //     'Fido',
        //     'Virgin Plus',
        //     'Lucky Mobile',
        //     'Chatr',
        //     'Other'
        // ];

        // const reasons = [
        //     '',
        //     'Upgrade',
        //     'New Activation',
        //     'Add a Line',
        //     'Bring Your Own Device',
        //     'Device Support',
        //     'Billing',
        //     'Accessory',
        //     'Other'
        // ];

        // carriers.forEach(item => {
        //     this.fields.carrier.append(
        //         $('<option>', {
        //             value: item,
        //             text: item || 'Select...'
        //         })
        //     );
        // });

        // reasons.forEach(item => {
        //     this.fields.reason.append(
        //         $('<option>', {
        //             value: item,
        //             text: item || 'Select...'
        //         })
        //     );
        // });
    }

    open(store) {
        this.clearBookingError();
        // this.$stepTitle.text(
        //     window.appointmentTranslations.select_date
        // );

        this.state.store = store;
        // this.state.appointment.bookingSite  = store.bookingSite ;
        this.reset();
        this.populateStore();
        // this.loadDates();

        this.$modal
            .attr('aria-hidden', 'false')
            .addClass('is-visible');

        $('body').css('overflow', 'hidden');
    }

    close() {

        this.$modal
            .attr('aria-hidden', 'true')
            .removeClass('is-visible');

        $('body').css('overflow', '');

        this.state.confirmation = null;

        this.reset();
    }

    isOpen() {
        return this.$modal.hasClass('is-visible');
    }

    populateStore() {
        const store = this.state.store;
        this.$storeName.text(store.name);
        this.$storeAddress.text(store.address);
        this.$storePhone.text(store.phone);
    }

    reset() {

        this.state.step = 0;

        this.state.appointment = {
            bookingSite: null,
            slot: null,
            date: null,
            time: null,
            bookingToken: null
        };

        // Restore the date picker
        this.$dateSection.removeClass('is-collapsed');

        // Hide the selected date summary
        this.$dateSummary
            .hide()
            .attr('hidden', true);

        // Clear dates/times
        this.$dates.empty();
        this.$times.empty();

        this.$dates.find('.appointment-date')
            .removeClass('is-selected');

        this.$times.find('.appointment-time')
            .removeClass('is-selected');

        this.goToStep(0);

        Object.keys(this.state.customer).forEach(key => {
            this.state.customer[key] = '';
        });

        this.fields.firstName.val('');
        this.fields.lastName.val('');
        this.fields.email.val('');
        this.fields.phone.val('');

        this.clearErrors();
        this.clearBookingError();
    }

    goToStep(step) {
        this.state.step = step;
        this.$confirmationIcon = this.$modal.find('[data-confirmation-icon]');
        this.$pages.removeClass('is-active');
        this.$pages
            .filter(`[data-page="${step}"]`)
            .addClass('is-active');

        this.$pagesContainer.scrollTop(0);

        switch (step) {
            case 0:
                this.$confirmationIcon.prop('hidden', true);
                this.$stepLabel.text('');
                this.$stepTitle.text(
                    document.documentElement.lang?.toLowerCase().startsWith('fr')
                        ? 'Conditions de réservation de rendez-vous.'
                        : 'Appointment booking terms and conditions.'
                );

                this.$back.prop('hidden', true);

                this.$next
                    .prop('hidden', false)
                    .text(window.appointmentTranslations.continue)
                    .prop('disabled', false);

                break;
            case 1:
                this.$confirmationIcon.prop('hidden', true);
                this.$stepLabel.text(window.appointmentTranslations.step1);
                this.$stepTitle.text(window.appointmentTranslations.select_date);
                this.$back.prop('hidden', true);
                this.$next.prop('hidden', false);
                this.$next
                    .text(window.appointmentTranslations.continue)
                    .prop('disabled', true);
                break;
            case 2:
                this.$confirmationIcon.prop('hidden', true);
                this.$stepLabel.text(window.appointmentTranslations.step2);
                this.$stepTitle.text(window.appointmentTranslations.information);
                this.$back.prop('hidden', false);
                this.$next.prop('hidden', false);
                this.$next
                    .text(window.appointmentTranslations.book)
                    .prop('disabled', false);

                setTimeout(() => {
                    this.fields.firstName.trigger('focus');
                }, 100);
                break;
            case 3:
                this.$confirmationIcon.prop('hidden', false);
                this.$stepLabel.text('');
                this.$stepTitle.text(window.appointmentTranslations.confirmed);

                this.$back.prop('hidden', true);

                this.$next
                    .prop('hidden', false)
                    .text('Close')
                    .prop('disabled', false);

                setTimeout(() => {
                    this.$stepTitle.trigger('focus');
                }, 100);
                break;
        }
    }

    next() {

        if (this.state.step === 0) {
            this.loadDates();
            this.goToStep(1);
            return;
        }

        if (this.state.step === 1) {
            this.goToStep(2);
            return;
        }

        if (this.state.step === 2) {
            this.bookAppointment();
            return;
        }

        if (this.state.step === 3) {
            this.close();
            return;
        }
    }

    back() {
        this.clearBookingError();

        if (this.state.step === 2) {
            this.goToStep(1);
            this.$stepTitle.text(
                window.appointmentTranslations.select_time
            );
        }
    }

    async loadDates() {

        const minDaysAhead = 0; // today
        const maxDaysAhead = 6; // 7 days

        this.$dates.empty();
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const locale = document.documentElement.lang?.toLowerCase().startsWith('fr') ? 'fr-CA' : 'en-CA';

        for (let i = minDaysAhead; i <= maxDaysAhead; i++) {
            const date = new Date(today);

            date.setDate(today.getDate() + i);

            const iso = [
                date.getFullYear(),
                String(date.getMonth() + 1).padStart(2, '0'),
                String(date.getDate()).padStart(2, '0')
            ].join('-');
            const weekday = date.toLocaleDateString(locale, {
                weekday: 'short'
            });

            const monthDay = date.toLocaleDateString(locale, {
                month: 'short',
                day: 'numeric'
            });

            this.$dates.append(`
                <button
                    type="button"
                    class="appointment-date"
                    data-date="${iso}"
                >
                    <span class="appointment-date__weekday">
                        ${weekday}
                    </span>

                    <span class="appointment-date__day">
                        ${monthDay}
                    </span>
                </button>
            `);
        }
    }

    selectDate($card) {
        this.clearBookingError();

        this.$dates
            .find('.appointment-date')
            .removeClass('is-selected');

        $card.addClass('is-selected');
        this.state.appointment.date = $card.data('date');
        this.loadTimes(this.state.appointment.date);
    }

    // async fetchAvailability(date) {

    //     const response = await fetch(
    //         `/apps/waitwell/availability?bookingSite=${encodeURIComponent(this.state.store.bookingSite)}&date=${date}`
    //     );

    //     if (!response.ok) {
    //         throw new Error('Unable to load availability');
    //     }

    //     return response.json();
    // }

    async loadTimes(date) {

        this.state.appointment.time = null;
        this.$next.prop('disabled', true);
        this.$times.empty();

        this.setDateLoading(true);
        this.showLoading();

        try {
            const response = await fetch(
                `/apps/waitwell/appointments/availability?bookingSite=${this.state.store.bookingSite}&date=${date}`
            );

            const data = await response.json();
            const noAppointments = document.documentElement.lang?.toLowerCase().startsWith('fr') ? 'Aucun rendez-vous disponible.' : 'No appointments available.';
            this.state.appointment.bookingToken = data.bookingToken;

            if (!data.rows.length) {
                this.$times.html('<p class="appointment-no-times">' + noAppointments + '</p>');
                return;
            }

            const slots = data.rows[0].slots || [];

            if (!slots.length) {
                this.$times.html(`
                    <div class="appointment-no-times">
                        No appointments available.
                    </div>
                `);

                return;
            }

            slots.forEach(slot => {

                const $button = $(`
                    <button
                        type="button"
                        class="appointment-time"
                    >
                        ${slot.StartTime}
                    </button>
                `);

                $button.data('slot', slot);

                this.$times.append($button);
            });

            const selectedDate = this.formatLocalDate(date);
            const locale = document.documentElement.lang?.toLowerCase().startsWith('fr')
                ? 'fr-CA'
                : 'en-CA';

            this.$selectedDate.text(
                selectedDate.toLocaleDateString(locale, {
                    weekday: 'short',
                    month: 'short',
                    day: 'numeric'
                })
            );

            this.$stepTitle.text(
                window.appointmentTranslations.select_time
            );

            this.$dateSection.addClass('is-collapsed');
            this.$dateSummary.removeAttr('hidden').hide().slideDown(250);

            // const $first = this.$times.find('.appointment-time').first();

            // if ($first.length) {

            //     // Smoothly scroll the modal body to the time list
            //     const pages = this.$modal.find('.appointment-pages')[0];

            //     const target =
            //         this.$stepHeader[0].offsetTop +
            //         this.$stepHeader[0].offsetHeight -
            //         10;

            //     pages.scrollTo({
            //         top: target,
            //         behavior: 'smooth'
            //     });

            //     this.$stepTitle.text(window.appointmentTranslations.select_time);

            //     this.$stepTitle[0].focus({
            //         preventScroll: true
            //     });

            // }
        } catch (err){
            console.error(err);
        } finally {
            this.hideLoading();
            this.setDateLoading(false);
        }
    }

    formatLocalDate(dateString) {

        const [year, month, day] = dateString
            .split('-')
            .map(Number);

        return new Date(year, month - 1, day);
    }
   
    selectTime($card) {
        this.clearBookingError();

        this.$times
            .find('.appointment-time')
            .removeClass('is-selected');

        $card.addClass('is-selected');

        const slot = $card.data('slot');

        this.state.appointment.slot = slot;
        this.state.appointment.time = slot.StartTime;
        this.state.appointment.date = slot.start.substring(0, 10);

        this.$next.prop('disabled', false);
    }

    async bookAppointment() {

        this.clearBookingError();

        this.state.customer = {
            firstName: this.fields.firstName.val().trim(),
            lastName: this.fields.lastName.val().trim(),
            email: this.fields.email.val().trim(),
            phone: this.fields.phone.val().trim(),
            // carrier: this.fields.carrier.val()
        };

        if (!this.validateForm()) {
            return;
        }

        if (this.state.submitting) {
            return;
        }

        this.state.submitting = true;

        // this.$next
        //     .prop('disabled', true)
        //     .text('Booking...');

        this.setSubmitting(true);
        // this.$bookingError = this.$modal.find('[data-booking-error]');

        const payload = {
            bookingSite: this.state.store.bookingSite,
            slot: this.state.appointment.slot,
            customer: this.state.customer,
            lang: document.documentElement.lang.startsWith('fr') ? 'fr' : 'en',
            bookingToken: this.state.appointment.bookingToken
        };

        try {
            const { response, result } =
                await this.sendBookingRequest(payload);
                        
            if (!response.ok || result.success === false) {

                await this.refreshAvailability();

                // this.showBookingError(
                //     result.message || 'Unable to book your appointment.'
                // );
                this.showBookingError(
                    window.appointmentTranslations.booking_error
                );

                if (
                    result.message &&
                    result.message.toLowerCase().includes('not available')
                ) {
                    await this.refreshAvailability();
                }

                return;
            }

            // Success!
            this.clearBookingError();
            this.state.confirmation = result.data;
            this.state.appointment.slot = null;
            this.populateConfirmation();
            this.goToStep(3);

        } catch (err) {
            console.error(err);
            
            await this.refreshAvailability();

             this.showBookingError(
                'Unable to contact the booking server. Please try again.'
            );      
        } finally {
            this.state.submitting = false;
            this.setSubmitting(false);
        }
    }

    async sendBookingRequest(payload) {

        const maxRateLimitRetries = 1;

        for (let attempt = 0; ; attempt++) {
            const response = await fetch(
                '/apps/waitwell/appointments/book',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                }
            );

            const result = await response.json();

            if (
                response.status !== 429 ||
                attempt >= maxRateLimitRetries
            ) {
                return { response, result };
            }

            const retryAfterSeconds = Number(
                result.retryAfterSeconds
            );
            const waitMilliseconds = (
                Number.isFinite(retryAfterSeconds) &&
                retryAfterSeconds > 0
                    ? retryAfterSeconds
                    : 60
            ) * 1000 + Math.floor(Math.random() * 1000);

            this.showBookingStatus(this.getBusyMessage());

            await new Promise(resolve => {
                setTimeout(resolve, waitMilliseconds);
            });
        }
    }

    getBusyMessage() {
        if (window.appointmentTranslations.booking_busy) {
            return window.appointmentTranslations.booking_busy;
        }

        return document.documentElement.lang
            ?.toLowerCase()
            .startsWith('fr')
            ? 'Nous sommes actuellement un peu occupés. Veuillez patienter pendant que nous confirmons votre réservation.'
            : 'We are currently a bit busy. Please wait while we confirm your booking.';
    }

    showBookingStatus(message) {
        this.$bookingMessage
            .text(message)
            .removeAttr('hidden')
            .show();
    }

    showBookingError(message) {
        this.showBookingStatus(message);
    }

    clearBookingError() {
        this.$bookingMessage
            .hide()
            .attr('hidden', true)
            .text('');
    }

    clearErrors() {
        Object.values(this.errors).forEach($error => {
            $error
                .text('')
                .removeClass('is-visible');
        });

        this.$contactError
            .text('')
            .removeClass('is-visible');

        Object.values(this.fields).forEach($field => {
            $field.removeAttr('aria-invalid');
        });
    }

    showError(field, message) {
        this.errors[field]
            .text(message)
            .addClass('is-visible');

        this.fields[field]
            .attr('aria-invalid', 'true');
    }

    // showFieldError(field, message) {

    //     const $error = this.$modal.find(`[data-error-for="${field}"]`);

    //     $error
    //         .text(message)
    //         .addClass('is-visible');
    // }

    // clearFieldError(field) {

    //     const $error = this.$modal.find(`[data-error-for="${field}"]`);

    //     $error
    //         .removeClass('is-visible')
    //         .text('');
    // }

    showLoading() {
        this.$loading.removeAttr('hidden');
        this.$times.empty();
    }

    hideLoading() {
        this.$loading.attr('hidden', true);
    }

    setDateLoading(isLoading) {
        this.$dates
            .find('.appointment-date')
            .prop('disabled', isLoading);
    }

    validateForm() {
        this.clearErrors();
        let valid = true;
        const customer = this.state.customer;

        if (!customer.firstName) {
            document.documentElement.lang?.toLowerCase().startsWith('fr') ? this.showError('firstName', 'Le prénom est requis.') : this.showError('firstName', 'First name is required.');
            valid = false;
        }

        if (!customer.lastName) {
            document.documentElement.lang?.toLowerCase().startsWith('fr') ? this.showError('lastName', 'Le nom est requis.') : this.showError('lastName', 'Last name is required.');
            valid = false;
        }

        // At least one contact method is required:
        // either email OR phone number.
        // At least one contact method is required.
        if (!customer.email && !customer.phone) {

            document.documentElement.lang?.toLowerCase().startsWith('fr') ? 
                this.$contactError
                .text('Veuillez indiquer soit une adresse électronique, soit un numéro de téléphone.')
                .addClass('is-visible') : 
                this.$contactError
                .text('Please provide either an email address or phone number.')
                .addClass('is-visible');

            valid = false;
        }

        // If email was provided, validate its format.
        if (customer.email) {

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailRegex.test(customer.email)) {
                this.showError(
                    'email',
                    'Please enter a valid email.'
                );

                valid = false;
            }

        }

        // if (!customer.carrier) {
        //     this.showError('carrier', 'Please select your current carrier.');
        //     valid = false;
        // }

        // if (!customer.reason) {
        //     this.showError('reason', 'Please select a reason.');
        //     valid = false;
        // }

        return valid;
    }

    async refreshAvailability() {

        this.state.appointment.slot = null;
        this.state.appointment.time = null;

        this.$times
            .find('.appointment-time')
            .removeClass('is-selected');

        this.$next.prop('disabled', true);

        await this.loadTimes(
            this.state.appointment.date
        );

        this.$times[0]?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });

    }

    populateConfirmation() {
        const booking = this.state.confirmation;
        const locale = document.documentElement.lang.toLowerCase().startsWith('fr') ? 'fr-CA' : 'en-CA';

        this.$modal.find('[data-confirmation-number]').text(booking.id);

        this.$modal.find('[data-confirmation-date]')
            .text(
                new Date(booking.start).toLocaleDateString(
                    locale,
                    {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    }
                )
            );

        this.$modal.find('[data-confirmation-time]').text(booking.AptStartTime.substring(0,5));
        this.$modal.find('[data-confirmation-store]').text(this.state.store.name);
        this.$modal.find('[data-confirmation-email]').text(booking.Email);
    }
}

window.appointmentModal = new AppointmentModal();
